module.exports = new __parcel__URL__("welcome-to-project-pages-spork-rebranding.b02d9616.png").toString();